<template>
	<b-form-select :options="options"/>
</template>

<script>
	export default {
		props:{
			"data":Object
		},
		computed:{
			options(){
				let r = this.data.settings.options.slice();
				r.unshift({ value: null, text: "--", disabled:true })
				return r;
			}
		}
	}
</script>